/* ===================== */
/* ======= PROMO ======= 066EFF */
/* ===================== */

export const PROMO = [
  {
    index: "31",
    type: "promo",
    title: "2º AÑO",
    artist: "MixtapeRadio",
    comentario: "(MIX STREAM MUSIC)",
    link: "descubre",
    playlistBg: "#FF6600",
    imgUrl: "./image/app/deck3.jpg",
    imgUrlB: "./assets/videos/blue-mixtape.mp4",
    imgUrlC: "./image/app/deck.jpg",
    imgUrlD: "./assets/videos/fire.mp4",
    hoverColor: "#FF6600",
    artistImgUrl: "./image/djs/alibhtty/alibhtty.jpg",
    artistBio: "Follow",
    artistDownload: "Descargar",
    bannerUno: "",
    downloadData: [],
  },
  {
    index: "32",
    type: "promo",
    title: "Promotion",
    comentario: " PROMO 2",
    link: "descubre",
    playlistBg: "#FF6600",
    imgUrl: "./image/app/deck3.jpg",
    imgUrlD: "./assets/videos/fire.mp4",
    hoverColor: "#FF6600",
    artist: "Ali Bhtty",
    artistImgUrl: "./image/djs/alibhtty/alibhtty.jpg",
    artistBio: "Follow",
    artistDownload: "Descargar",
    bannerUno: "",
    downloadData: [],
  },
];

export const anuncios = [
  {
	index: "ad-1",
	songName: "Anuncio Sponsor 1",
	songimg: "../image/djs/mixtape/mixtape.png",
	songArtist: "Sponsor 1",
	link: "https://dl.dropbox.com/s/nokuxvpxr75bzni/BOX%20CAR%20-%20TAKING%20OVER.mp3",
	trackTime: "00:10",
	isAd: true,
  },
  {
	index: "ad-2",
	songName: "Anuncio Sponsor 2",
	songimg: "../image/djs/mixtape/mixtape.png",
	songArtist: "Sponsor 1",
	link: "./assets/audio/ad-mixtape.mp3",
	trackTime: "00:10",
	isAd: true,
  },
];
